// tslint:disable:max-line-length

import React from 'react';

export const ChartPercentArea = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="8,5.4 4,7.9 0,5.8 0,10.9 3.9,12.2 7.8,9.2 12,10.2 16,8.9 16,5.3 12,7.3" />
      <polygon opacity=".3" points="12,11.8 8.2,10.8 4.1,13.8 0,12.5 0,16 16,16 16,10.5" />
      <polygon opacity=".3" points="4,6.1 8,3.6 12,5.7 16,3.7 16,0 0,0 0,4.2" />
    </svg>
  );
};
